// region External libraries
import * as _ from "lodash";
// endregion External libraries
// region Organisms
import { PageTabProps } from "@organisms/PageTabs";
// endregion Organisms

/**
 * Get action tab index
 * @param addNewTab - Return number of the new tab
 * @param currentTabs - Array of current menu tabs
 * @param idOfTabToAdd - Id of the supply tab
 * @returns Action tab index
 */
const addTab = (
  addNewTab: (newTab: PageTabProps) => number,
  currentTabs: PageTabProps[],
  idOfTabToAdd: string
) => {
  const newTab = _.cloneDeep(currentTabs.find((tab) => tab.id === idOfTabToAdd));

  if (!newTab) throw new Error("Tab not found.");

  return addNewTab(newTab);
};

export { addTab };